import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=7d5ca0d2&"
import script from "./categorias.vue?vue&type=script&lang=ts&"
export * from "./categorias.vue?vue&type=script&lang=ts&"
import style0 from "./categorias.vue?vue&type=style&index=0&id=7d5ca0d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports